<div class="illustration-container">
  <img *ngIf="isResolutionMobile"
    [src]="'images/ifood-landing/header-ifood-landing.svg' | assetsUrl"
    alt="Ilustración principal"
    class="main-landing-img"
    [ngClass]="(isClientNotEnrolled || isEnrolled) ? 'main-landing-img--short' : 'main-landing-img--tall'"
  />
  <img *ngIf="!isResolutionMobile"
    [src]="'images/ifood-landing/header-ifood-landing-desk.svg' | assetsUrl"
    alt="Ilustración principal"
    class="main-landing-img"
    [ngClass]="(isClientNotEnrolled || isEnrolled) ? 'main-landing-img--short' : 'main-landing-img--tall'"
  />
  <div class="texto-sobre-imagen">
    <span class="texto-sobre-imagen--linea1">{{ getLandingText().linea1 }}</span><br />
    <span class="texto-sobre-imagen--linea2">{{ getLandingText().linea2 }}</span>
  </div>
  <div class="landing-cajitas-row" *ngIf="!isClientNotEnrolled && !isEnrolled">
    <div class="landing-cajita">
      <img [src]="'images/ifood-landing/benefit_passport.svg' | assetsUrl" alt="Beneficio Passaporte" class="landing-cajita-icono" />
      <span class="landing-cajita-texto">Transforme seus pontos em viagens</span>
    </div>
    <div class="landing-cajita">
      <img [src]="'images/ifood-landing/benefit_percentage.svg' | assetsUrl" alt="Beneficio Porcentaje" class="landing-cajita-icono" />
      <span class="landing-cajita-texto">Até 25% OFF nos produtos Decolar</span>
    </div>
    <div class="landing-cajita">
      <img [src]="'images/ifood-landing/benefit_coupon.svg' | assetsUrl" alt="Beneficio Cupon" class="landing-cajita-icono" />
      <span class="landing-cajita-texto">Cupons exclusivos de até 40% OFF</span>
    </div>
  </div>
  <img [src]="'images/ifood-landing/logo-d-ifood.svg' | assetsUrl" alt="Logos Decolar e iFood" class="logos-decolar-ifood" />
  <div class="landing-iconos-texto" [ngClass]="{'landing-iconos-texto--up': isEnrolled || isClientNotEnrolled}">
    <div class="avatar-socialproof">
      <img [src]="'images/ifood-landing/avatar-socialproof.png' | assetsUrl" alt="Social Proof" class="avatar-socialproof" />
    </div>
    <span class="landing-texto-conexiones">{{ getLandingText().main }}</span>
  </div>
</div>
<div *ngIf="!isClientNotEnrolled && !isEnrolled" class="landing-boton-conectar-wrapper">
  <button class="landing-boton-conectar" (click)="onConnectIfoodClick('main')">Conectar minha conta iFood</button>
</div>

